import React from 'react';
import { Container } from 'react-bootstrap';

function Home() {
    return (
        <div>
            <Container fluid className="limited-width bg ogs-pri-text text-center py-5 mb-5">
                <h1 className="ogs-sec-text mb-3">Smart solutions for all your business needs, OGS guaranteed.</h1>
            </Container>

            <Container fluid className="limited-width bg ogs-pri-text text-center py-5 mb-5">
                <p className="ogs-pri-text mb-4">
                    At <b className="ogs-high-text">Omni Group Services (OGS)</b>, we help businesses get things done – from robust software systems to practical support that keeps operations moving.
                    With more than 10 years of hands-on development experience, technology is our core, but we don't stop there.
                    <br /><br />
                    Need a reliable web or mobile app, integrations that actually talk to each other, or help modernising an old system? We can design, build, and support it.
                    Looking for a partner who understands both IT and day-to-day business needs? That's where we fit in.
                    <br /><br />
                    Think of OGS as your versatile problem-solving partner: focused on quality, easy to work with, and serious about delivering results – with a bit of personality along the way.
                </p>
            </Container>
        </div>
    );
}

export default Home;
